/**
 * Activity-log action strings that represent a status change. Backend emits
 * "approved" | "rejected" (terminal approve since IPD-400); the "final ..." and
 * "finalized" actions are historical, kept so old timelines still render.
 */
export const STATUS_CHANGE_ACTIONS = new Set([
  "approved",
  "rejected",
  "final approved",
  "final rejected",
  "finalized",
]);
